import { FC, useState } from 'react';
import { Box, ButtonProps, Button } from '@mui/material';
import LoadingScreen from './LoadingScreen';

interface TetherButtonProps extends ButtonProps {
  loading?: boolean;
}

const TetherButton: FC<TetherButtonProps> = (props) => {
  const { loading, children, onClick, disabled, sx, ...other } = props;
  const [processing, setProcessing] = useState(false);

  return (
    <Button
      {...other}
      onClick={async (event) => {
        if (onClick) {
          setProcessing(true);
          try {
            await Promise.resolve(onClick(event));
          } finally {
            setProcessing(false);
          }
        }
      }}
      // `loading` disables too, not just spins. Callers that run their own async work and
      // report it through `loading` — rather than through this button's `onClick` — were
      // otherwise leaving the control live for the whole request: AttachUserForm passes
      // `onClick={() => {}}`, so `processing` is true for one microtask and a second click
      // re-entered the submit handler and fired the POST again.
      disabled={disabled || processing || loading}
      sx={{
        ...sx,
      }}
    >
      {children}
      <Box sx={{ display: 'flex', maxHeight: '15px', maxWidth: '15px', marginLeft: '5px' }}>
        {(loading || processing) && <LoadingScreen sx={{ width: '15px', display: 'flex' }} />}
      </Box>
    </Button>
  );
};

export default TetherButton;
